import React from 'react';

const User = () => {

    // - - - - - - - - - - - - - - - - - - - - - - - - -

    // ==================================================
    // ==================================================
    return(
        <div className="flex flex-col gap-4">
            <div className="flex max-md:flex-col gap-4 items-center px-10 pt-6 pb-2">
                <img
                    className="block mx-auto h-24 w-24 rounded-full sm:mx-0 sm:shrink-0"
                    src="https://tailwindcss.com/img/erin-lindford.jpg"
                    alt="User profile picture"
                />

                <div className="content-center flex flex-col gap-2 sm:text-left">
                    <h4 className="text-xl font-bold mb-3">Erin Lindford</h4>
                    <p className="card-text max-md:text-center">Based on the results, your personality is lorem ipsum text.</p>
                </div>
            </div>
            <div>
                <div className="flex justify-between text-sm gap-10 bg-gray-100 px-10 py-4">
                    <p className="card-text">Age: <strong>10 years</strong></p>
                    <p className="card-text">Gender: <strong>Male</strong></p>
                    <p className="card-text">Location: <strong>USA</strong></p>
                </div>
            </div>
        </div>
    );
};

export default User;